﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailBehaeltertyp extends GuiDetailGeneric {
    constructor() {
        super("GuiDetailBehaeltertyp");
    }
}